import { SalesDashboardView } from './SalesDashboardView'
import { SalesBySellerView } from './SalesBySellerView'
import { SalesByOfferingView } from './SalesByOfferingView'
import { useParams } from '@tanstack/react-router'

export const SalesCnt = () => {
  const params = useParams({ strict: false }) as { sellerId?: string; offeringId?: string }

  if (params.sellerId) {
    return <SalesBySellerView />
  }

  if (params.offeringId) {
    return <SalesByOfferingView />
  }

  return <SalesDashboardView />
}
